import { useTranslation } from 'react-i18next'
import { Box, Button, Grid } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { Photo, FieldReportPhoto } from '@/types'
import { ChosenFile } from '@/hooks'
import { getFileNameFromUrl } from '@/utils'
import { DownloadCloud } from 'react-feather'
import { CustomTooltip } from '@/components/ui'

export type EntityPhotoProps = {
  photo: ChosenFile | Photo
  onDelete?: () => void
}

export const EntityPhoto = ({
  photo,
  onDelete,
}: EntityPhotoProps): JSX.Element => {
  const { t } = useTranslation()

  // Check if photo is a FieldReportPhoto by checking for is_valid property
  const isFieldReportPhoto = 'is_valid' in photo
  const isInvalid = isFieldReportPhoto && !(photo as FieldReportPhoto).is_valid
  const validationError = isInvalid
    ? (photo as FieldReportPhoto).validation_error
    : ''

  return (
    <Grid item={true} md={3}>
      <Box position="relative">
        <a href={photo.link} target="_blank" rel="noreferrer">
          {photo.type === 'video' ? (
            <Box style={{ height: '150px' }} flex={1} alignContent="center">
              {getFileNameFromUrl(photo.link, true)}{' '}
              <DownloadCloud size="16px" />
            </Box>
          ) : (
            <img
              src={photo.link}
              style={{
                width: '100%',
                height: 'auto',
                borderRadius: 4,
                border:
                  isInvalid && validationError ? '2px solid #f44336' : 'none', // Add red border for invalid photos
              }}
              alt=""
            />
          )}
        </a>
        {!!onDelete && (
          <Button
            onClick={onDelete}
            variant="contained"
            size="small"
            color="error"
            style={{ position: 'absolute', top: 5, right: 5 }}
          >
            {t('common:buttons.delete')}
          </Button>
        )}

        {/* Display error icon with tooltip for invalid photos */}
        {isInvalid && validationError && (
          <CustomTooltip title={validationError} arrow={true} placement="top">
            <ErrorOutlineIcon
              color="error"
              style={{
                position: 'absolute',
                bottom: 10,
                right: 5,
                backgroundColor: 'white',
                borderRadius: '50%',
                padding: 2,
              }}
            />
          </CustomTooltip>
        )}
      </Box>
    </Grid>
  )
}
